import kotlinx.coroutines.ExperimentalForInheritanceCoroutinesApi
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.FlowCollector

@OptIn(ExperimentalForInheritanceCoroutinesApi::class)
interface EventStateFlow<T> : StateFlow<T?> {
    fun reset()
    fun send(event: T)
    fun reset(event: T) { if (value == event) reset() }
}

class MutableEventStateFlow<T> : EventStateFlow<T> {
    private val _flow = MutableStateFlow<T?>(null)
    private val pendingEvents = ArrayDeque<T>()
    override val value: T?
        get() = _flow.value
    override val replayCache: List<T?>
        get() = _flow.replayCache
    override fun reset() {
        _flow.value = pendingEvents.removeFirstOrNull()
    }
    override fun send(event: T) {
        if (_flow.value == null) {
            _flow.value = event
        } else {
            pendingEvents.addLast(event)
        }
    }
    override fun reset(event: T) {
        if (value == event) reset()
    }

    fun asStateFlow(): StateFlow<T?> = _flow.asStateFlow()
    override suspend fun collect(collector: FlowCollector<T?>) = _flow.collect(collector)
}
